import { TRANSLATION_CONSTANTS as T } from 'src/utils/translations';

// 1. Change /react/ to /string/
import { AT, IT, DE, CH, GB, US } from 'country-flag-icons/string/3x2';

// 2. Helper to make them usable in <img src="..." />
const toDataUrl = (svg: string) =>
  `data:image/svg+xml;utf8,${encodeURIComponent(svg)}`;

export const countriesList = [
  { code: '+43', label: 'Austria', flag: toDataUrl(AT) },
  { code: '+39', label: 'Italy', flag: toDataUrl(IT) },
  { code: '+49', label: 'Germany', flag: toDataUrl(DE) },
  { code: '+41', label: 'Switzerland', flag: toDataUrl(CH) },
  { code: '+44', label: 'United Kingdom', flag: toDataUrl(GB) },
  { code: '+1', label: 'United States', flag: toDataUrl(US) }
];
export const MAX_DOMAIN_CHAR = 20;
export const SCHEME = 'https://';

export const PASSWORD_POLICY_REGEX =
  /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!@#$%^&*(),.?":{}|<>_]).{8,}$/;

export const LOADING_STEPS = [
  T.creatingTenant,
  T.settingUpWorkspaces,
  T.configuringPreferences,
  T.finalizingAccountSettings
] as const;

export const getPostDomainPart = (baseUrl?: string) => {
  // TODO: This should be config specific not location href, a config should pass and use the domain part
  const url = new URL(baseUrl || window.location.origin);
  const parts = url.hostname.split('.');

  if (parts.length > 1) {
    return parts.slice(1).join('.');
  }
  return url.hostname;
};
